// extracted by mini-css-extract-plugin
export default {"tabs":"l_bh","tab-list":"l_bj","tab":"l_bk","active":"l_bl"};